export const CALENDAR_JALALI = "jalali";
export const CALENDAR_GREGORIAN = "gregorian";

export const GREGORIAN_MONTHS = [
  "ژانویه",
  "فوریه",
  "مارس",
  "آوریل",
  "مه",
  "ژوئن",
  "ژوئیه",
  "اوت",
  "سپتامبر",
  "اکتبر",
  "نوامبر",
  "دسامبر",
];

export function normalizeCalendarType(value) {
  const raw = String(value || "")
    .trim()
    .toLowerCase();
  if (raw === CALENDAR_GREGORIAN || raw === "gregory" || raw === "miladi") {
    return CALENDAR_GREGORIAN;
  }
  return CALENDAR_JALALI;
}

export function calendarTypeLabel(value) {
  return normalizeCalendarType(value) === CALENDAR_GREGORIAN ? "میلادی" : "شمسی";
}

export function gregorianDaysInMonth(year, month) {
  const y = Number(year);
  const m = Number(month);
  if (!Number.isFinite(y) || m < 1 || m > 12) return 30;
  return new Date(y, m, 0).getDate();
}

export function getCurrentGregorianDate() {
  const now = new Date();
  return {
    year: now.getFullYear(),
    month: now.getMonth() + 1,
    day: now.getDate(),
  };
}

export function getGregorianDateFromDate(date = new Date()) {
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
  };
}

export function yearsForCalendar(calendarType, jalaliYear) {
  if (normalizeCalendarType(calendarType) === CALENDAR_GREGORIAN) {
    const y = new Date().getFullYear();
    return [y - 1, y, y + 1];
  }
  const year = Number(jalaliYear) || getCurrentGregorianDate().year;
  return Array.from(new Set([year - 1, year, year + 1, 1404, 1405])).sort(
    (a, b) => a - b,
  );
}

export function monthLabel(month, calendarType) {
  const m = Number(month);
  if (normalizeCalendarType(calendarType) === CALENDAR_GREGORIAN) {
    return GREGORIAN_MONTHS[m - 1] || String(month);
  }
  return null;
}

export function round2(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100) / 100;
}
